import { defineStore } from 'pinia';

export const useOverlays = defineStore('overlays', {
    state: () => ({
        initialLoad: true,
        sending: false,
    }),
});
